<ng-container *ngIf="showSession; else elseTemplate">
  <div *ngIf="occurrence" class="classdetail-row">
    <div class="classdetail-content">
      {{occurrence.duration}}
      <span translate>teacher.invoices.class-with </span>
      <span>{{occurrence.student.user.first_name}} {{occurrence.student.user.last_name}}</span>
    </div>
    <div class="classdetail-date">
      {{occurrence.start | amLocale: 'en' | amDateFormat:'MMM DD YYYY, HH:mm'}}-{{occurrence.end | amLocale: 'en' | amDateFormat:'HH:mm'}}
    </div>
    <div class="classdetail-content classdetail-status">
     {{ getStatusOccurrenceLabel(occurrence.status) }}
    </div>
  </div>
  <div *ngIf="session" class="classdetail-row">
    <div class="classdetail-content">
      {{session.duration}}
      <span translate>teacher.invoices.lilate-with </span>
      <span>{{session.lilate.student.user.first_name}} {{session.lilate.student.user.last_name}}</span>
    </div>
    <div class="classdetail-date" *ngIf="session && session.start && session.end">
      {{session.start | amLocale: 'en' | amDateFormat:'MMM DD YYYY, HH:mm'}}-{{session.end | amLocale: 'en' | amDateFormat:'HH:mm'}}
    </div>
    <div class="classdetail-content classdetail-status">
     {{ getStatusSessionStatusLabel(session.status) }}
    </div>
  </div>
</ng-container>
<ng-template #elseTemplate>
  <i translate>teacher.invoices.loading</i>
</ng-template>